export const COLLAPSE_DIRECTIVE_LOCALE_ZHCHS = {
    expand: 'å±å¼',
    fold: 'æ¶èµ·'
}
